
const SearchSVG = () => {

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_814_2646)">
                <path fillRule="evenodd" clipRule="evenodd" d="M15.6906 19.0923C14.1932 20.022 12.4487 20.5773 10.5962 20.6191C5.19911 20.741 0.91624 16.4581 1.03804 11.061C1.15984 5.66393 5.64046 1.18331 11.0375 1.06147C16.4346 0.939707 20.7175 5.22258 20.5957 10.6196C20.5539 12.4721 19.9985 14.2167 19.0688 15.714L22.2974 18.9426C23.1877 19.8329 23.1543 21.3119 22.2229 22.2433L22.2199 22.2464C21.2885 23.1778 19.8095 23.2112 18.9192 22.3209L15.6906 19.0923ZM10.9607 4.46334C7.4412 4.54278 4.51931 7.46467 4.43987 10.9842C4.36046 14.5038 7.15341 17.2967 10.673 17.2173C14.1925 17.1379 17.1144 14.216 17.1938 10.6964C17.2733 7.17688 14.4803 4.38393 10.9607 4.46334Z" fill="#F4F3F3"/>
            </g>
            <defs>
                <clipPath id="clip0_814_2646">
                    <rect width="24" height="24" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )

}

export default SearchSVG;
